export interface AitiCoreWebsiteData {
    id: number;
    code: string;
    name: string;
}

export default class AitiCoreWebsite {

    private _data: AitiCoreWebsiteData;

    init(data: AitiCoreWebsiteData) {
        this._data = data;
    }

    getId(): number {
        return this._data.id;
    }

    getCode(): string {
        return this._data.code;
    }

    getName(): string {
        return this._data.name;
    }
}
